"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CPNIHSService = void 0;
const operators_1 = require("rxjs/operators");
const restservice_1 = require("./restservice");
const http_1 = require("@angular/common/http");
class CPNIHSService extends restservice_1.RestService {
    constructor() {
        super(...arguments);
        this.cpniHsInformation = '/rest/model/cellularsouth/content/ContentRepositoryActor?id=/generic/disclaimer/cpniInformation';
        this.cpinHsCheckUrl = '/rest-api/fiber/account/cpni/v1/check/';
        this.createHsPinUrl = '/rest-api/fiber/account/cpni/v1/create';
        // validateHsCpniUrl= '/rest-api/fiber/account/validateCPNI';
        this.validateHsCpniUrl = '/rest-api/fiber/account/cpni/v1/validate';
    }
    getCpniHsInformation() {
        return this.get(this.cpniHsInformation).pipe(operators_1.map((data) => data));
    }
    cpinHsCheck(value) {
        if (value != null || value !== undefined) {
            return this.get(this.cpinHsCheckUrl + value).pipe(operators_1.map((data) => data));
        }
        else {
            return this.get(this.cpinHsCheckUrl).pipe(operators_1.map((data) => data));
        }
    }
    createHsPin(value) {
        const content = {
            'ssn': value.ssn,
            'isExpressPay': value.isExpressPay,
        };
        const inputArgs = new http_1.HttpParams().set('lastFourSSN', content.ssn).set('expressPay', content.isExpressPay);
        return this.post(this.createHsPinUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    validateHs(value) {
        const content = {
            'pin': value.pin,
            'isExpressPay': value.isExpressPay,
        };
        const inputArgs = new http_1.HttpParams().set('cpniCode', content.pin).set('expressPay', content.isExpressPay);
        /* return this.post(this.validateHsCpniUrl + pin)
          .map((data: any) => {
              return data;
        });*/
        return this.post(this.validateHsCpniUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
}
exports.CPNIHSService = CPNIHSService;
//# sourceMappingURL=hscpni.service.js.map